module.exports = __webpack_public_path__ + "static/media/receta-24.ee7c9e2b.png";